import { loading, error, success } from 'State/actions';
import { PagingFilterTypeEnum } from 'Common/Constants/Enumeration/PagingFilterTypeEnum';

import * as types from './types';

export const fetchStudents = (
  pageNumber = 1,
  filters = [],
  sortColumns = [],
  showWithdrawn = false
) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.STUDENTLOOKUP_FETCHING, true));

    try {
      const model = {
        PageNumber: pageNumber,
        ShowWithDrawn: showWithdrawn,
        PageSize: 10,
        SiteId: 'ALL',
        Filter: [
          ...filters.map((filter) => ({
            FilterName: filter.id,
            FilterValue: filter.value,
            FilterType:
              Object.values(PagingFilterTypeEnum).find(
                (i) => i === filter.filterType
              ) || PagingFilterTypeEnum.MatchFromStart,
          })),
          { FilterName: 'NoHouseholdId', FilterValue: true },
          { FilterName: 'AppStatuses', FilterValue: true },
        ],
        SortColumn: sortColumns.map((sortColumn) => ({
          SortName: sortColumn.id,
          SortDirection: sortColumn.desc ? 'desc' : 'asc',
        })),
      };

      const response = await MPWWebApi.postGenericInsertUpdate(
        'Student/ApplicationStudents',
        model
      );

      dispatch(success(types.STUDENTLOOKUP_FETCH, response.data));
    } catch (ex) {
      dispatch(error(types.STUDENTLOOKUP_FETCH_ERROR, ex));
    }

    dispatch(loading(types.STUDENTLOOKUP_FETCHING, false));
  };
};

export const addStudentToApp = (student) => {
  return {
    type: types.STUDENTLOOKUP_ADD_STUDENT,
    payload: student,
  };
};



// WEBPACK FOOTER //
// ./src/pages/manageapplication/state/studentlookup/actions.js